import DateFnsUtils from "@date-io/date-fns";
import {
	Button,
	Grid,
	MenuItem,
	Typography,
	makeStyles,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DecodedJWT, ReactHookFormSelect } from "../../utils";

const userStyles = makeStyles((theme) => ({
	optionDiv: {
		gap: theme.spacing(3),
		backgroundColor: "white",
		padding: theme.spacing(1),
		marginBottom: theme.spacing(3),
		boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
		borderRadius: "5px 5px 5px 5px",
		[theme.breakpoints.down("xs")]: {
			gap: 0,
		},
	},

	datePicker: {
		width: "100%",
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginBottom: theme.spacing(2),
		},
	},

	button: {
		height: "3.3rem",
		width: "6rem",
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginBottom: theme.spacing(4),
		},
	},
}));

export const OptionHandle = ({
	stateOption,
	handleSearch,
	state,
	setState,
	MultiHandleOptionsTask,
	singleOption,
}) => {
	const classes = userStyles();
	const { handleSubmit, errors, control } = useForm();
	const decode = DecodedJWT();
	useEffect(() => {
		MultiHandleOptionsTask({
			params: {
				id: decode.id,
				idlayanan: state.idlayanan,
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.idlayanan]);

	return (
		<div style={{ paddingTop: "1rem" }}>
			<Grid container alignItems="center" className={classes.optionDiv}>
				<Grid item xs={12} sm={2} md={2}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<DatePicker
							// autoOk
							className={classes.datePicker}
							orientation="landscape"
							inputVariant="outlined"
							openTo="date"
							value={state.tgl_awal}
							label="Start Time"
							onChange={(e) =>
								setState({ ...state, tgl_awal: moment(e).format("YYYY-MM-DD") })
							}
							disableFuture
						/>
					</MuiPickersUtilsProvider>
				</Grid>

				<Grid item xs={12} sm={2} md={2}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<DatePicker
							// autoOk
							className={classes.datePicker}
							orientation="landscape"
							inputVariant="outlined"
							openTo="date"
							value={state.tgl_akhir}
							label="End Time"
							onChange={(e) =>
								setState({
									...state,
									tgl_akhir: moment(e).format("YYYY-MM-DD"),
								})
							}
							disableFuture
						/>
					</MuiPickersUtilsProvider>
				</Grid>

				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="idpriority"
						name="idpriority"
						label="Pilih Priority"
						control={control}
						error={errors.idpriority}
						value={state.idpriority}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID Prioriy tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						{singleOption &&
							singleOption.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.idpriority && (
						<Typography variant="caption" color="error">
							{errors.idpriority.message}
						</Typography>
					)}
				</Grid>

				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="idlayanan"
						name="idlayanan"
						label="Pilih Layanan"
						control={control}
						error={errors.idlayanan}
						value={state.idlayanan}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID layanan tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						isForm
						fullWidth
					>
						<MenuItem value="none" disabled selected>
							--Pilih Layanan--
						</MenuItem>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						{stateOption.option1 &&
							stateOption.option1.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.idlayanan && (
						<Typography variant="caption" color="error">
							{errors.idlayanan.message}
						</Typography>
					)}
				</Grid>

				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="idstatus"
						name="idstatus"
						label="Pilih Status"
						control={control}
						error={errors.idstatus}
						value={state.idstatus}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID Status tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						<MenuItem value="1" disable></MenuItem>
						{stateOption.option2 &&
							stateOption.option2.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.idstatus && (
						<Typography variant="caption" color="error">
							{errors.idstatus.message}
						</Typography>
					)}
				</Grid>

				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="idkategori"
						name="idkategori"
						label="Pilih Kategori"
						control={control}
						error={errors.idkategori}
						value={state.idkategori}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID Kategori tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="none" disabled selected>
							--Pilih Kategori--
						</MenuItem>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						{stateOption.optionResult &&
							stateOption.optionResult.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.idkategori && (
						<Typography variant="caption" color="error">
							{errors.idkategori.message}
						</Typography>
					)}
				</Grid>

				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="time"
						name="time"
						label="Pilih Time"
						control={control}
						error={errors.time}
						value={state.time}
						// handleOption={handleOption}
						rules={{
							required: {
								value: true,
								message: `ID Time tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						<MenuItem value="in time" selected>
							IN TIME
						</MenuItem>
						<MenuItem value="out time" selected>
							OUT TIME
						</MenuItem>
					</ReactHookFormSelect>
					{errors.time && (
						<Typography variant="caption" color="error">
							{errors.time.message}
						</Typography>
					)}
				</Grid>

				<Grid item xs={12} sm={2} md={2}>
					<Button
						className={classes.button}
						variant="contained"
						color="primary"
						onClick={handleSubmit(handleSearch)}
					>
						Filter
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default OptionHandle;
